import React from "react";
import { Provider } from "react-redux";
import { ProductReviewsPageResult } from "./definitions";
import ProductReviewsHeading from "./ProductReviewsHeading/ProductReviewsHeading";
import Reviews from "~/common/Reviews/Reviews";
import { defaultUserObject } from "~/common/Store/rootReducer";
import Store from "~/common/Store";
import useIsMounted from "~/common/useIsMounted";
import LoginModalWrapper from "~/common/LoginModal/LoginModalWrapper";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";
import ReviewsV2 from "~/common/Reviews";

const ProductReviews = (productReviewsPageResult: ProductReviewsPageResult) => {
  const {
    isEverliving,
    brandName,
    description,
    extendedDescription,
    itemNumber,
    link,
    image,
    customerReviews,
    ratingDistribution,
    totalRatings,
    customMetaHeader,
    featureFlags,
  } = productReviewsPageResult;
  const mounted = useIsMounted();

  const filterByRatingEnabled = featureFlags?.["filter-by-rating"] ?? false;

  return (
    <Provider store={Store}>
      <FeatureFlagProvider featureFlags={featureFlags}>
        <div
          className="container"
          id="mainProductContentContainer"
          itemType="https://schema.org/Product"
        >
          <div id="page" role="main" className="product-page">
            <div>
              {filterByRatingEnabled ? (
                <ReviewsV2
                  brand={brandName}
                  itemNumber={itemNumber}
                  reviews={customerReviews}
                  mounted={mounted}
                  isEverliving={isEverliving}
                  usePagination
                  isProductReviewPage
                  image={image}
                  description={description}
                  productLink={link}
                  extendedDescription={extendedDescription}
                  customMetaHeader={customMetaHeader}
                />
              ) : (
                <>
                  <ProductReviewsHeading
                    description={description}
                    extendedDescription={extendedDescription}
                    customMetaHeader={customMetaHeader}
                    image={image}
                    itemNumber={itemNumber}
                    customerReviews={customerReviews}
                    link={link}
                    ratingDistribution={ratingDistribution}
                    totalRatings={totalRatings}
                  />
                  <Reviews
                    user={defaultUserObject}
                    brand={brandName}
                    itemNumber={itemNumber}
                    reviews={customerReviews}
                    mounted={mounted}
                    isEverliving={isEverliving}
                    usePagination
                    isProductReviewPage
                    image={image}
                    description={description}
                    productLink={link}
                  />
                </>
              )}
            </div>
          </div>
          <LoginModalWrapper />
        </div>
      </FeatureFlagProvider>
    </Provider>
  );
};

export default ProductReviews;
